import { render, staticRenderFns } from "./onDuty.vue?vue&type=template&id=c95013e6&scoped=true"
import script from "./onDuty.vue?vue&type=script&lang=js"
export * from "./onDuty.vue?vue&type=script&lang=js"
import style0 from "./onDuty.vue?vue&type=style&index=0&id=c95013e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95013e6",
  null
  
)

export default component.exports